import { render, staticRenderFns } from "./login-main.vue?vue&type=template&id=7ca02f42&scoped=true";
import script from "./login-main.vue?vue&type=script&lang=js";
export * from "./login-main.vue?vue&type=script&lang=js";
import style0 from "./login-main.vue?vue&type=style&index=0&id=7ca02f42&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "7ca02f42", null);
export default component.exports;